<template functional>
    <div class="search-badge tw-flex tw-justify-center tw-items-center tw-ml-4">
        <i class="far" :class="[{'fa-crown': props.admin},{'fa-cog': props.moderator}]"></i>
        <span>{{props.admin ? 'Admin' : 'Moderator'}}</span>
    </div>
</template>

<script>
export default {
	name: 'label',
	props: {
		admin: {
			type: Boolean,
		},
		moderator: {
			type: Boolean,
		},
	},
};
</script>

<style lang="scss" scoped>
.search-badge {
    background: rgba(33, 150, 243, 0.1);
    padding: 4px 6px;
    border-radius: 11px;
    color: #2196F3;
    height: 21px;
    font-size: 11px;

    i {
        margin-right: 4px;
    }
}
</style>
